// extracted by mini-css-extract-plugin
module.exports = {"ComingSoonContainer":"ComingSoon_ComingSoonContainer__WS-Bv"};